import * as React from "react";
import S from "./StandardEditor.styled";
import { motion } from "framer-motion";
import { motionAnimation } from "@/styles/global";

export interface StandardEditorProps {
  blockId: string;
  wysiwygContent: string;
}

const StandardEditor: React.FC<StandardEditorProps> = ({
  wysiwygContent,
  blockId = "",
}) => {
  return (
    <S.Section as={motion.section} {...motionAnimation} id={blockId}>
      <S.Inner>
        <S.Content dangerouslySetInnerHTML={{ __html: wysiwygContent }} />
      </S.Inner>
    </S.Section>
  );
};

export default StandardEditor;
